// extracted by mini-css-extract-plugin
export var historyImageWrapper = "history-module--history-image-wrapper--sJ4d6";
export var historyTextWrapper = "history-module--history-text-wrapper--4xtOY";
export var historyTopWrapper = "history-module--history-top-wrapper--cm-i+";
export var historyWrapper = "history-module--history-wrapper--+B3XA";